import { createReducer, on } from '@ngrx/store';
import { ReminderActions } from './reminder.actions';
import { ReminderState, reminderState } from './reminder.state';

export const reminderReducer = createReducer(
  reminderState,
  on(
    ReminderActions.reset,
    (): ReminderState => ({ faceScanStatus: null, latestFaceScanProcess: null })
  ),
  on(
    ReminderActions.setLatestFaceScanProcess,
    (state, { latestFaceScanProcess }): ReminderState => ({
      ...state,
      latestFaceScanProcess
    })
  ),
  on(
    ReminderActions.setFaceScanStatus,
    (state, { faceScanStatus }): ReminderState => ({
      ...state,
      faceScanStatus
    })
  )
);
